import { statusConstants } from "../constants";

export const industryOptions = [
  "Accounting",
  "Business Process Outsourcing (BPO)",
  "Advertising",
  "Agriculture & Crop Production",
  "Photography",
  "Public Relations (PR)",
  "Publishing",
  "Purchasing & Procurement",
  "Virtual Assistant Services",
  "Mechanical Engineering",
  "Merchandising",
  "Modeling & Talent Agency",
  "Residential & Nursing Care Services",
  "Oil & Gas",
  "Medial Hospital",
  "Heavy Industry & Metallurgy",
  "Journalism",
  "Manufacturing",
  "Marketing",
  "Mining & Quarrying",
  "Biotechnology",
  "Safety & Environment",
  "Fashion Design",
  "Graphic Design",
  "Sports & Outdoor Activities",
  "Administration Support Services",
  "Airlines",
  "Facilities & Property Management",
  "Automotive Dealership & Distributor",
  "Real Estate",
  "Catering, Food Service, & Restaurant",
  "Retail & Wholesale",
  "Sales Outsourcing",
  "Scientific Research & Development",
  "Law Firm",
  "Industrial Production",
  "Military & Defense",
  "Other Business Support Services",
  "Personal Care Centers",
  "IT Services",
  "Installation & Technical Services",
  "Insurance & TPA",
  "Internet & E-commerce",
  "Law Enforcement & Civil Defense",
  "Public Administration",
  "Other Healthcare Services",
  "Medical Clinic",
  "Hospitality & Accomodation",
  "Human Resources Outstanding",
  "Primary, Prep, & Secondary School",
  "Recruitement & Employee Placement Agency",
  "General Engineering Consultancy",
  "Economics & Financial Consulting",
  "Financial Services",
  "Computer Hardware & High-Tech Manufacture",
  "Software Development",
  "Constructions & Building",
  "Business Consultancy Services",
  "Call Centers & Customer Care Outstanding",
  "Architecture",
  "Media Production",
  "Banking",
  "Pharmaceutical Manufacturing",
  "Non-profit Organization",
  "Private Security Services",
  "Shipping",
  "Technical Maintenance & Repair",
  "Telecommunications",
  "Telemarketing",
];

export const getStatusPill = (status) => {
  const statusMap = {
    [statusConstants.PENDING]: {
      label: statusConstants.PENDING_LABEL,
      class: "pill pill-pending",
    },
    [statusConstants.INPROGRESS]: {
      label: statusConstants.INPROGRESS_LABEL,
      class: "pill pill-inprogress",
    },
    [statusConstants.COMPLETED]: {
      label: statusConstants.COMPLETED_LABEL,
      class: "pill pill-completed",
    },
    [statusConstants.OPEN]: {
      label: statusConstants.OPEN_LABEL,
      class: "pill pill-open",
    },
    [statusConstants.HOLD]: {
      label: statusConstants.HOLD_LABEL,
      class: "pill pill-hold",
    },
    [statusConstants.CLOSED]: {
      label: statusConstants.CLOSED_LABEL,
      class: "pill pill-closed",
    },
  };

  const item = statusMap[status];

  if (!item) {
    return <span className="pill pill-unknown">Unknown</span>;
  }

  return <span className={item.class}>{item.label}</span>;
};

export const getAllCurrencies = () => {
  return [
    { country: "United States", currency: "USD", name: "US Dollar", symbol: "$" },
    { country: "Canada", currency: "CAD", name: "Canadian Dollar", symbol: "$" },
    { country: "United Kingdom", currency: "GBP", name: "Pound Sterling", symbol: "£" },
    { country: "European Union", currency: "EUR", name: "Euro", symbol: "€" },
    { country: "Japan", currency: "JPY", name: "Japanese Yen", symbol: "¥" },
    { country: "China", currency: "CNY", name: "Chinese Yuan", symbol: "¥" },
    { country: "Australia", currency: "AUD", name: "Australian Dollar", symbol: "$" },
    { country: "New Zealand", currency: "NZD", name: "New Zealand Dollar", symbol: "$" },
    { country: "Pakistan", currency: "PKR", name: "Pakistani Rupee", symbol: "₨" },
    { country: "India", currency: "INR", name: "Indian Rupee", symbol: "₹" },
    { country: "Saudi Arabia", currency: "SAR", name: "Saudi Riyal", symbol: "﷼" },
    { country: "United Arab Emirates", currency: "AED", name: "UAE Dirham", symbol: "د.إ" },
    { country: "Turkey", currency: "TRY", name: "Turkish Lira", symbol: "₺" },
    { country: "Russia", currency: "RUB", name: "Russian Ruble", symbol: "₽" },
    { country: "Brazil", currency: "BRL", name: "Brazilian Real", symbol: "R$" },
    { country: "Mexico", currency: "MXN", name: "Mexican Peso", symbol: "$" },
    { country: "South Africa", currency: "ZAR", name: "South African Rand", symbol: "R" },
    { country: "South Korea", currency: "KRW", name: "South Korean Won", symbol: "₩" },
    { country: "Switzerland", currency: "CHF", name: "Swiss Franc", symbol: "CHF" },
    { country: "Singapore", currency: "SGD", name: "Singapore Dollar", symbol: "$" },
    { country: "Malaysia", currency: "MYR", name: "Malaysian Ringgit", symbol: "RM" },
    { country: "Thailand", currency: "THB", name: "Thai Baht", symbol: "฿" },
    { country: "Indonesia", currency: "IDR", name: "Indonesian Rupiah", symbol: "Rp" },
    { country: "Philippines", currency: "PHP", name: "Philippine Peso", symbol: "₱" },
    { country: "Nigeria", currency: "NGN", name: "Nigerian Naira", symbol: "₦" },
    { country: "Egypt", currency: "EGP", name: "Egyptian Pound", symbol: "£" },
    { country: "Argentina", currency: "ARS", name: "Argentine Peso", symbol: "$" },
    { country: "Bangladesh", currency: "BDT", name: "Bangladeshi Taka", symbol: "৳" },
    { country: "Vietnam", currency: "VND", name: "Vietnamese Dong", symbol: "₫" },
  ];
};

// Helper function to get value from object using dot notation with array support
export const getPropertyValue = (obj, path) => {
  if (!obj || !path || typeof path !== "string") {
    return undefined;
  }

  // Trim any whitespace
  path = path.trim();
  if (path === "") {
    return undefined;
  }

  try {
    // Split by dots but preserve array notation
    const regex = /[\.]+(?![^\[]*\])/g; // Split by dots not inside brackets
    const parts = path.split(regex).filter(Boolean);
    let current = obj;

    for (let part of parts) {
      if (current === null || current === undefined) {
        return undefined;
      }

      // Check if this part contains array notation
      if (part.includes("[")) {
        // Handle nested array notation like "array[0][1].property"
        const subparts = part.split(/\[|\]\.?/).filter(Boolean);

        for (let subpart of subparts) {
          if (subpart === "") continue;

          // Check if subpart is a number (array index)
          const index = parseInt(subpart, 10);

          if (!isNaN(index) && Array.isArray(current)) {
            // Array index access
            if (index < 0 || index >= current.length) {
              return undefined;
            }
            current = current[index];
          } else {
            // Property access
            current = current[subpart];
          }

          if (current === null || current === undefined) {
            return undefined;
          }
        }
      } else {
        // Simple property access
        current = current[part];
      }
    }

    return current;
  } catch (error) {
    console.warn(`Error accessing path "${path}":`, error);
    return undefined;
  }
};

// Helper function to convert date to epoch seconds
export const convertDateToEpochSeconds = (date) => {
  if (!date) return null;
  return Math.floor(new Date(date).getTime() / 1000);
};

// Helper function to format date to YYYY-DD-MM HH:MM:SS
export const formatDateToCustomFormat = (epochSeconds) => {
  if (!epochSeconds) return "";

  const date = new Date(epochSeconds * 1000);

  // Format: YYYY-DD-MM HH:MM:SS
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};